import React, { useEffect, Fragment } from 'react'
import initActionButtons from '../../action_buttons/action_buttons'
import neptune_i18n from '../../../../utilities/translation'
import { ShareProps } from '../types'

// NOTE: (BB 12/2019)
// Until this module can be rewritten, we're going to hack in the action buttons script
// for parity.
const language = document.documentElement.lang
const currentLocation = window.location
const Actions = ({ personalize }: ShareProps) => {
  useEffect(() => {
    initActionButtons('#mp_weather_react')
  }, [])

  return (
    <div className="block-item__actions">
      {personalize ? (
        <button
          id="personalize"
          data-mp-three-dots-button
          className="button button__icon button__icon--personalize svg--dark"
          type="button"
          data-mp-share-title=""
          data-mp-share-link=""
          data-mp-content-api-id=""
          data-gtm-id="three_dots"
          aria-label={neptune_i18n('Three Dots')}
          data-modal-custom-trigger-target-personalization="modal--personalize"
          data-gtm-event-type="click-element"
          data-gtm-event-category="Three Dots"
          data-gtm-event-action="weather_widget_block"
          data-gtm-event-label={currentLocation}
        >
          <div
            className="icon-three-dots"
            data-gtm-id="three_dots"
            data-gtm-event-type="click-element"
            data-gtm-event-category="Three Dots"
            data-gtm-event-action="weather_widget_block"
            data-gtm-event-label={currentLocation}
          ></div>
        </button>
      ) : (
        <Fragment>
          <button
            className="button button__icon icon icon--share icon--light ${language}"
            type="button"
            data-mp-button-share
            data-gtm-id="share"
          >
            <div>${neptune_i18n('share', language)}</div>
          </button>
          <button
            className="button button__icon icon icon--feedback icon--light ${language}"
            type="button"
            data-modal-custom-trigger-target-feedback="modal--feedback"
            data-gtm-id="feedback"
          >
            <div>${neptune_i18n('feedback', language)}</div>
          </button>
        </Fragment>
      )}
    </div>
  )
}

export default Actions
